export const documentProps = {
  title: 'How It Works — Our 5-Step Business Automation Process',
  description:
    'Discovery → Workflow Mapping → Build → Launch → Optimize. See exactly how TenK Solutions automates your operations in 4–6 weeks with zero vendor lock-in.',
};
